// Get the current URL and any parameters specified therein
const urlParams = new URLSearchParams(window.location.search)
const random = Math.random()

function displayImages(station) {
  const mapTemps = document.getElementById('map-temps')
  const feelsLike = document.getElementById('map-feelslike')
  const mapWinds = document.getElementById('map-winds')
  const mapSatRad = document.getElementById('map-satrad')
  const map12hrs = document.getElementById('map-12hrs')
  const map24hrs = document.getElementById('map-24hrs')
  const map36hrs = document.getElementById('map-36hrs')
  const map48hrs = document.getElementById('map-48hrs')
  const mapFutureRadar = document.getElementById('map-futureradar')
  const mapDay1 = document.getElementById('map-day1')
  const mapDay2 = document.getElementById('map-day2')
  const mapDay3 = document.getElementById('map-day3')

  mapTemps.src = `https://pbsweather.org/maps/FL/currents/${station}-Temps.jpg?random=${random}`
  feelsLike.src = `https://pbsweather.org/maps/FL/currents/${station}-FeelsLike.jpg?random=${random}`
  mapWinds.src = `https://pbsweather.org/maps/FL/currents/${station}-Winds.jpg?random=${random}`
  mapSatRad.src = `https://pbsweather.org/maps/FL/radars/${station}-Radar.gif?random=${random}`
  map12hrs.src = `https://pbsweather.org/maps/FL/forecasts/${station}-12hrs.jpg?random=${random}`
  map24hrs.src = `https://pbsweather.org/maps/FL/forecasts/${station}-24hrs.jpg?random=${random}`
  map36hrs.src = `https://pbsweather.org/maps/FL/forecasts/${station}-36hrs.jpg?random=${random}`
  map48hrs.src = `https://pbsweather.org/maps/FL/forecasts/${station}-48hrs.jpg?random=${random}`
  mapFutureRadar.src = `https://pbsweather.org/maps/FL/futureradar/FL-FutureRadar.gif?random=${random}`
  mapDay1.src = `https://pbsweather.org/maps/FL/forecasts/FL-Day1.jpg?random=${random}`
  mapDay2.src = `https://pbsweather.org/maps/FL/forecasts/FL-Day2.jpg?random=${random}`
  mapDay3.src = `https://pbsweather.org/maps/FL/forecasts/FL-Day3.jpg?random=${random}`
}

function loadmaps() {
  if (urlParams.has('station')) {
    const station = urlParams.get('station').toUpperCase()
    displayImages(station)
  } else {
    displayImages('FL')
  }
}

export { loadmaps }

// Code for determining 404 - Needs more doing
// fetch('https://floridastorms.org/maps/FL/currents/XXXX-Temps.jpg', { method: 'HEAD' })
//   .then(response => {
//     if (response.ok) {
//       console.log('Image exists.')
//     } else {
//       console.log('Image does not exist.')
//     }
//   })
//   .catch(err => console.log('Error:', err))